module.exports = __webpack_public_path__ + "static/media/display-2.dffbbcb5.png";